import { STRINGS } from '@/constants/strings';
import type { RemovalReason } from '@/services/remove-player-guardian';
import * as yup from 'yup';

/** Reuse the shared validation copy so guardian forms stay consistent. */
const MESSAGES = STRINGS.mutatePlayer.validation;

/** Max length of the free-text removal detail (blocks input beyond this). */
export const MAX_REMOVE_DETAIL_LENGTH = 500;

/** Selectable removal reasons, in display order. */
export const REMOVAL_REASON_VALUES: RemovalReason[] = [
  'no_longer_co_parenting',
  'safety_concern',
  'other',
];

/**
 * Remove Co-Guardian form — a required reason, an optional detail note (≤500 chars) and a
 * required acknowledgement checkbox. `reason` starts empty so nothing is preselected.
 */
export const removeCoGuardianSchema = yup
  .object({
    reason: yup
      .mixed<RemovalReason>()
      .oneOf(REMOVAL_REASON_VALUES, MESSAGES.fieldRequired)
      .required(MESSAGES.fieldRequired),
    detail: yup.string().trim().defined().max(MAX_REMOVE_DETAIL_LENGTH),
    acknowledged: yup.boolean().defined().oneOf([true], MESSAGES.fieldRequired),
  })
  .required();

export type RemoveCoGuardianForm = {
  reason: RemovalReason | '';
  detail: string;
  acknowledged: boolean;
};

export const INITIAL_REMOVE_CO_GUARDIAN_FORM: RemoveCoGuardianForm = {
  reason: '',
  detail: '',
  acknowledged: false,
};
